<template>
  <div class="col px-0">

    <BaseUtil
      ref="util"
      :pageLoading="loading"
    />

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Fluxo de Caixa
    </div>

    <!-- <v-row>
      <v-col cols="12"> -->
    <v-card>  
      <v-card-title>
        <span>Filtros</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="4" md="3">
            <v-autocomplete
              v-model="periodFilterModel"
              label="Período"
              :items="periodFilterOptions"
              item-value="key"
              item-text="name"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="periodFilterModel == 'OTHER'">
            <DateRangeField
              :inputData.sync="periodFilterRangeModel"
              label="Período Customizado"
              :hasTodayDate="true"
            />
          </v-col>

          <v-col cols="12" sm="8" md="7">
            <v-autocomplete
              v-model="bankAccountsFilterModel"
              label="Conta(s) Bancária(s)"
              :items="bankAccountsList"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="bankAccountsFilterModel = []"
              :loading="loading"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhuma conta bancária for selecionada, todas serão exibidas"
              persistent-hint
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeSelectedBankAccount(data.item)"
                >
                  {{ data.item.name }} <small class="font-italic font-weight-light ml-2 mt-1"> ({{numberToCurrency(data.item.currentBalance)}}) </small>
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item-action>
                  <v-checkbox :input-value="data.attrs.inputValue"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{data.item.name}}</v-list-item-title>
                  <v-list-item-subtitle>Saldo Atual: {{numberToCurrency(data.item.currentBalance)}}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-btn
              class="mt-3"
              @click="runFilter(false)">
              <v-icon left>mdi-magnify</v-icon>
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
      <!-- </v-col> -->

    <!-- </v-row> -->
    <!-- sortByField="dueDate" -->
    <!-- :sortDesc="false" -->

    <div class="d-flex">
      <BasePrint
        printableElementId="cashBookReportPrintTable"
        printButtonLabel="Imprimir"
        printTitle="Relatório de Fluxo de Caixa"
        @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false"
        class="mt-3"
      />

      <v-btn
        color="success"
        class="mt-3 ml-2"
        @click="sendProjectedCashflowReport"
      >
        Enviar Relatório por E-mail
        <v-icon right dark>mdi-email-send</v-icon>
      </v-btn>
      
    </div>

    <div id="cashBookReportPrintTable">

      <v-row>
        <v-col cols="12" class="">
          <BaseIndex
            ref="baseIndex"
            v-if="cashBook"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="tableHeaders"
            :table-items="cashBook.installments"
            :maskFields="maskFields"
            :itemClass="itemClasses"
            :enableCustomFilters="false"
            :containTopToolbar="false"
            :containSearchBar="false"
            :itemsPerPage="-1"
            :disablePagination="true"
            :indexNested="true"
            :hasDefaultPageTitle="false"
          >
            <template slot="edit" slot-scope="{ item }">
              <CashOutflowInstallmentEdit
                v-if="item.type == 'CashOutflowInstallment'"
                :entry="item"
                :editOnly="true"
                :readOnly="true"
                modelNameSingular="Parcela a Pagar"
              />
              <CashInflowInstallmentEdit
                v-else-if="item.type == 'CashInflowInstallment'"
                :entry="item"
                :editOnly="true"
                :readOnly="true"
                modelNameSingular="Parcela a Receber"
              />
            </template>

            <template slot="link1" slot-scope="{ item }">
              <PurchaseEdit
                v-if="item.parentType == 'Purchase'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
                modelNameSingular="Compra"
              />
              <SaleEdit
                v-else-if="item.parentType == 'Sale'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
                modelNameSingular="Venda"
              />
              <ServiceProvisionEdit
                v-else-if="item.parentType == 'ServiceProvision'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
                modelNameSingular="Serviço"
              />
              <CashInflowEdit
                v-else-if="item.parentType == 'CashInflow'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
                modelNameSingular="Conta a Receber"
              />
              <CashOutflowEdit
                v-else-if="item.parentType == 'CashOutflow'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
                modelNameSingular="Conta a Pagar"
              />
              <DepositEdit
                v-else-if="item.parentType == 'Deposit'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
                modelNameSingular="Depósito"
              />
              <TransferEdit
                v-else-if="item.parentType == 'Transfer'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
                modelNameSingular="Transferência"
              />
              <WithdrawEdit
                v-else-if="item.parentType == 'Withdraw'"
                :entry="item.parentObject"
                :readTitle="'Visualizar ' + item.operationTypeText+ ' ' + item.parentObject.code"
                :readOnly="true"
                :isTextButton="true"
                :textButton="item.operationTypeText + ' ' + item.parentObject.code"
                modelNameSingular="Saque"
              />
            </template>
          
            <template slot="tableHeader">
              <tr class="d-none d-md-table-row">
                <td colspan="6" class="text-right title"><strong class="mx-3">Data de Início:</strong></td>
                <td class="text-left title"><strong>{{ this.cashBook.startDate | formatDate }}</strong></td>
                <td colspan="3" class="text-right title"><strong class="mx-3">Saldo Anterior:</strong></td>
                <td colspan="2" class="text-left title"><strong>{{ this.cashBook.previousBalance | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Data de Início</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashBook.startDate | formatDate }}</strong></div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Saldo Anterior</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashBook.previousBalance | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>

            <template slot="tableFooter">
              <tr class="d-none d-md-table-row">
                <td colspan="6" class="text-right title"><strong class="mx-3">Data de Fim:</strong></td>
                <td class="text-left title"><strong>{{ this.cashBook.endDate | formatDate }}</strong></td>
                <td colspan="3" class="text-right title"><strong class="mx-3">Saldo Final:</strong></td>
                <td colspan="2" class="text-left title"><strong>{{ this.cashBook.latestBalance | formatCurrency }}</strong></td>
              </tr>

              <!-- for mobile only -->
              <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Data de Fim</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashBook.endDate | formatDate }}</strong></div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">Saldo Final</div>
                  <div class="v-data-table__mobile-row__cell"><strong>{{ this.cashBook.latestBalance | formatCurrency }}</strong></div>
                </td>
              </tr>
            </template>
          </BaseIndex>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";
import PurchaseEdit from "@models/purchases/edit.vue";
import SaleEdit from "@models/sales/edit.vue";
import ServiceProvisionEdit from "@models/services_provision/edit.vue";
import CashInflowEdit from "@models/cash_flows/cash_inflows/edit.vue";
import CashOutflowEdit from "@models/cash_flows/cash_outflows/edit.vue";
import DepositEdit from "@models/bank_accounts/bank_account_operations/deposits/edit.vue";
import TransferEdit from "@models/bank_accounts/bank_account_operations/transfers/edit.vue";
import WithdrawEdit from "@models/bank_accounts/bank_account_operations/withdraws/edit.vue";
import CashOutflowInstallmentEdit from "@models/installments/cash_outflow_installments/edit.vue";
import CashInflowInstallmentEdit from "@models/installments/cash_inflow_installments/edit.vue";
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      cashBook: null,
      bankAccountsList: [],
      bankAccountsFilterModel: [],
      loading: true,
      pageLoading: false,
      monthFilter: moment().format('YYYY-MM'),
      startDate: null,
      endDate: null,
      tableHeaders: [
        { text: "Código", align: "left", sortable: false, value: "customCode"},
        { text: "Nº da NF-e", align: "left", sortable: false, value: "number"},
        // { text: "Operação", align: "left", sortable: false, value: "operationTypeText"},
        { text: "Operação", align: "left", sortable: false, value: "link" },
        // { text: "Status", align: "left", sortable: false, value: "status" },
        { text: "Cliente/Fornecedor", align: "left", sortable: false, value: "payment.cashFlow.customerOrSupplierName" },
        { text: "Plano de Contas", align: "left", sortable: false, value: "payment.cashFlow.chart.name"},
        { text: "Conta Bancária", align: "left", sortable: false, value: "bankAccount.name"},
        // { text: "Vencimento", align: "left", sortable: false, value: "dueDate"},
        { text: "Pagamento", align: "left", sortable: false, value: "paymentDate"},
        { text: "Valor da Parcela", align: "left", sortable: false, value: "value"},
        { text: "Valor Pago", align: "left", sortable: false, value: "totalOutPaidAmount"},
        { text: "Valor Recebido", align: "left", sortable: false, value: "totalInPaidAmount"},
        { text: "Saldo", align: "left", sortable: false, value: "partialBalance" },
        { text: "Ver", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'dueDate', mask: 'date' },
        { field: 'paymentDate', mask: 'date' },
        { field: 'value', mask: 'currency' },
        { field: 'totalOutPaidAmount', mask: 'currency' },
        { field: 'totalInPaidAmount', mask: 'currency' },
        { field: 'partialBalance', mask: 'currency' },
        // { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ],
      periodFilterOptions: [
        { "key": "DAY", "name": "Hoje" },
        { "key": "WEEK", "name": "Esta Semana" },
        { "key": "MONTH", "name": "Este Mês" },
        { "key": "OTHER", "name": "Customizado" },
      ],
      periodFilterModel: "DAY",
      periodFilterRangeModel: [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')]
    };
  },
  props: {
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
    PurchaseEdit: PurchaseEdit,
    SaleEdit: SaleEdit,
    ServiceProvisionEdit: ServiceProvisionEdit,
    CashInflowEdit: CashInflowEdit,
    CashOutflowEdit: CashOutflowEdit,
    DepositEdit: DepositEdit,
    TransferEdit: TransferEdit,
    WithdrawEdit: WithdrawEdit,
    CashOutflowInstallmentEdit: CashOutflowInstallmentEdit,
    CashInflowInstallmentEdit: CashInflowInstallmentEdit,
    BaseUtil: BaseUtil
  },
  created() {
    // if (this.$route.params.bankAccountId) {
    // this.bankAccountsFilterModel = this.$route.params.bankAccountId;
    this.periodFilterModel = "MONTH";
    // }
    this.runFilter(true);
  },
  mounted() {

  },
  methods: {
    loadServerEntries: function(firstLoading=false) {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CASH_BOOK,
          variables: {
            startDate: this.startDate,
            endDate: this.endDate,
            bankAccountIds: this.bankAccountsFilterModel
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.cashBook = response.data.accountContext.cashBookReport;
          if (!this.cashBook) {
            this.cashBook = {installments: []};
          }
          // this.bankAccountsList = [{"id": "0", "name": "Todas as Contas Bancárias"}].concat(response.data.accountContext.allBankAccounts);
          this.bankAccountsList = response.data.accountContext.allBankAccounts;
          if (firstLoading) {
            this.bankAccountsFilterModel = response.data.accountContext.allBankAccounts.map(bankAccount => bankAccount.id);
          }
          // this.bankAccountsList.prepend({"id": "", "name": "Todas Contas Bancárias"});
          // console.log("cashBook", this.cashBook);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    // entryUpdated: function(){
    //   this.loadServerEntries();
    //   this.$refs.baseIndex.showConfirmationMessage("Registro atualizado com sucesso!");
    // },
    // entryCreated: function(){
    //   this.loadServerEntries();
    //   this.$refs.baseIndex.showConfirmationMessage("Registro criado com sucesso!");
    // },
    // entryDeleted: function(){
    //   this.loadServerEntries();
    //   this.$refs.baseIndex.showConfirmationMessage("Registro removido com sucesso!");
    // },
    itemClasses: function(item) {
      // if (item.status == "pending_payment") {
        if (item.type == "CashOutflowInstallment") {
          return "cash_outflow_item";
        } else if (item.type == "CashInflowInstallment") {
          return "cash_inflow_item";
        }
      // }
    },
    runFilter: function(firstLoading=false) {
      if (this.periodFilterModel != "OTHER") {
        this.startDate = moment().startOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
        this.endDate   = moment().endOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');

      } else {
        if (this.periodFilterRangeModel.length == 2) {
          this.startDate = this.periodFilterRangeModel[0];
          this.endDate   = this.periodFilterRangeModel[1];
        }
      }
      // console.log(this.startDate, this.endDate);
      this.loadServerEntries(firstLoading);
      // this.startDate = moment(this.monthFilter, 'YYYY-MM').startOf('week').format('YYYY-MM-DD');
      // this.endDate   = moment(this.monthFilter, 'YYYY-MM').endOf('week').format('YYYY-MM-DD');
    },
    removeSelectedBankAccount: function(item) {
      const index = this.bankAccountsFilterModel.indexOf(item.id)
      if (index >= 0) this.bankAccountsFilterModel.splice(index, 1)
    },
    sendProjectedCashflowReport: function() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: SEND_CASHFLOW_BY_EMAIL_MUTATION,
          variables: {
            // open_installments = 1
            // all = 2
            // all_and_open = 3
            fileType: 3
          }
        })
        .then(response => {
          var sendCashflowByEmail = response.data.sendCashflowByEmail;
          // console.log("response", sendCashflowByEmail);

          if (sendCashflowByEmail.errors.length){
            this.formErrors = errors
          } 
          if (sendCashflowByEmail.success) {
            this.$refs.util.showConfirmationMessage("O relatório de parcelas foi criado e enviado ao seu e-mail!");
          }
          
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    }
  }
};

const LOAD_CASH_BOOK = gql `
query ($startDate: ISO8601Date!, $endDate: ISO8601Date!, $bankAccountIds: [ID!]!) {
  accountContext {
    cashBookReport(startDate: $startDate, endDate: $endDate, bankAccountIds: $bankAccountIds) {
      previousBalance
      latestBalance
      startDate
      endDate
      installments {
        id
        customCode
        bankAccount {
          name
        }
        value
        paidAmount
        totalPaidAmount
        totalOutPaidAmount
        totalInPaidAmount
        dueDate
        series
        number
        payment {
          cashFlow {
            chart {
              name
            }
            supplier {
              name
            }
            customer {
              name
            }
            customerOrSupplierName
          }
        }
        code
        paymentDate
        type
        operationTypeText
        parentType
        parentId
        parentObject
        status
        statusKey
        statusColor
        partialBalance
      }
    }
    allBankAccounts {
      id
      name
      currentBalance
    }
  }
}
`;

const SEND_CASHFLOW_BY_EMAIL_MUTATION = gql `
  mutation($fileType: Int!) {
    sendCashflowByEmail(fileType: $fileType) {
      success
      errors
    }
  }
`;

</script>

<style scoped>
  ::v-deep .cash_inflow_item {
    color: blue;
  }
  ::v-deep .cash_outflow_item {
    color: red;
  }
</style>
